
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DateTimePicker extends Vue {
    @Prop(String) readonly id!: string;

    @Prop({ type: String, default: '' }) readonly label!: string;

    @Prop(Boolean) readonly required!: boolean;

    @Prop({ type: Boolean, default: false }) readonly icon!: boolean;

    @Prop(Date) readonly minDate!: Date;

    @Prop(Date) readonly maxDate!: Date;

    @Prop({ type: Boolean, default: false }) readonly disabled!: string;

    @Prop({ type: String, default: 'dateTime' }) readonly mode!: string;

    @ModelSync('value', 'change', { type: Date })
    readonly formValue!: Date;

    mask = {
        input: 'YYYY.MM.DD',
        inputTime24hr: 'HH:mm',
        inputDateTime24hr: 'YYYY.MM.DD HH:mm',
    };
}
